module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/price-2-4a0545c03c7551617f90a80fed6c21f0.svg";